import API from "@/axios/api";

const state = {
    actions: [
        // {
        //     text: 'Дилеры',
        //     expanded: false,
        //     subActions: [
        //         {text: 'Добавить', icon: 'mdi-plus', link: '/dealers/add'},
        //         {text: 'Список', icon: 'mdi-format-list-bulleted', link: '/dealers'},
        //     ],
        //     disabled: false,
        // },
        // {
        //     text: 'Пользователи',
        //     expanded: false,
        //     subActions: [
        //         {text: 'Добавить', icon: 'mdi-plus', link: '/users/add'},
        //         {text: 'Список', icon: 'mdi-format-list-bulleted', link: '/users'},
        //     ],
        //     disabled: false
        // },
        // {
        //     text: 'Модули ПО',
        //     expanded: false,
        //     subActions: [
        //         {text: 'Добавить', icon: 'mdi-plus', link: '/modules/add'},
        //         {text: 'Список', icon: 'mdi-format-list-bulleted', link: '/modules'},
        //     ],
        //     disabled: false
        // },
        // {
        //     text: 'Мастер-лицензии',
        //     expanded: false,
        //     subActions: [
        //         {text: 'Добавить', icon: 'mdi-plus', link: '/masters/add'},
        //         {text: 'Список', icon: 'mdi-format-list-bulleted', link: '/masters'},
        //     ],
        //     disabled: false
        // },
        // {
        //     text: 'Объекты',
        //     expanded: false,
        //     subActions: [
        //         {text: 'Добавить', icon: 'mdi-plus', link: '/objects/add'},
        //         {text: 'Список', icon: 'mdi-format-list-bulleted', link: '/objects'},
        //     ],
        //     disabled: false
        // },
        // {
        //     text: 'Лицензии',
        //     expanded: false,
        //     subActions: [
        //         {text: 'Список', icon: 'mdi-format-list-bulleted', link: '/licenses'},
        //     ],
        //     disabled: false
        // },
        // {
        //     text: 'Logs & Reps',
        //     expanded: false,
        //     subActions: [
        //         {text: 'Login/Logout', icon: 'mdi-information-outline', link: '/reports/users/logins'},
        //         {text: 'Login Error', icon: 'mdi-information-outline', link: '/reports/users/errors'},
        //         {text: 'Окончание Мастер', icon: 'mdi-information-outline', link: '/reports/masters'},
        //         {text: 'Окончание Лицензий', icon: 'mdi-information-outline', link: '/reports/licenses'},
        //         {text: 'User Actions', icon: 'mdi-information-outline', link: '/reports/users/actions'},
        //     ],
        //     disabled: false
        // },
        // // {icon: 'mdi-cog', text: 'Настройки', link: '/settings/', disabled: false},
        // // {icon: 'mdi-message', text: 'Обратная связь', link: '/feedback/', disabled: true},
        // {icon: 'mdi-help-circle', text: 'Помощь', link: '/help/', disabled: true},
        // // {icon: 'mdi-export', text: 'Выход', link: '/exit/', disabled: true},
    ],
};

const getters = {
    sidebarActions: state => state.actions,
}

const actions = {
    async getDrawer({commit}) {
        await API.get('drawer')
            .then((response) => {
                commit('setActions', response.data.drawer)
            })
            .catch((error) => {
                console.log(error);
            });
    },
};

const mutations = {
    setActions(state, actions) {
        state.actions = actions;
    },
    expandAction(state, action) {
        state.actions.find(_action => _action.text === action.text).expanded = true;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
